<template>
  <a-drawer
    :confirmLoading='confirmLoading'
    :keyboard='false'
    :maskClosable='false'
    :title='title'
    :visible='visible'
    width='100%'
    @close='prev'>
    <a-spin :spinning='confirmLoading'>
      <a-steps :initial='0' :current='current'>
        <a-step description='选择映射更新字段' title='选择映射最终自动填充的表单字段'></a-step>
        <a-step description='选择公式数据源' title='选择公式中涉及的来源数据'></a-step>
        <a-step description='设置子公式' title='预配置特殊类型公式（可跳过）'></a-step>
        <a-step description='设置映射公式' title='根据数据源及子公式进行配置'></a-step>
        <a-step description='配置结果映射' title='进行结果映射（可跳过）'></a-step>
        <a-step description='映射描述'></a-step>
      </a-steps>
      <a-divider />
      <a-tabs v-model='current'>
        <a-tab-pane :key='0' tab=''>
          <step1 ref='step1' :model='model'></step1>
        </a-tab-pane>
        <a-tab-pane :key='1' tab=''>
          <step2 ref='step2' :model='model'></step2>
        </a-tab-pane>
        <a-tab-pane :key='2' tab=''>
          <step3 ref='step3' :model='model'></step3>
        </a-tab-pane>
        <a-tab-pane :key='3' tab=''>
          <step4 ref='step4' :model='model'></step4>
        </a-tab-pane>
        <a-tab-pane :key='4' tab=''>
          <step5 ref='step5' :model='model'></step5>
        </a-tab-pane>
        <a-tab-pane :key='5' tab=''>
          <step6 ref='step6' :model='model'></step6>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <div class='footer-btn'>
      <a-button style="margin-right: 12px" @click="prev">{{ cancelText }}</a-button>
      <a-button type="primary" @click="next">{{ okText }}</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postAction } from '@api/manage'
import Step1 from '@views/project/setting/mapping/Step1'
import Step2 from '@views/project/setting/mapping/Step2'
import Step3 from '@views/project/setting/mapping/Step3'
import Step4 from '@views/project/setting/mapping/Step4'
import Step5 from '@views/project/setting/mapping/Step5'
import Step6 from '@views/project/setting/mapping/Step6'

export default {
  name: 'MappingModel',
  components: { Step6, Step5, Step4, Step3, Step2, Step1 },
  data() {
    return {
      title: '新增映射',
      visible: false,
      model: {},
      confirmLoading: false,

      current: 0,
      cancelText: '关闭',
      okText: '下一步',

    }
  },
  created() {
  },
  methods: {
    add() {
      //初始化默认值
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    /*保存新增公式,触发请求*/
    handleOk() {
      const that = this

      this.$confirm({
        title: '再次确认',
        content: '确定要保存信息吗?',
        onOk() {
          that.confirmLoading = true
          postAction('?', that.model).then((res) => {
            if (res.success) {
              that.$message.success(res.message)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      })
    },

    handleCancel() {
      this.close()
    },
    /**
     * 下一步 每一步都需要验证表单
     */
    next() {
      //当前步骤表单验证
      const step = this.$refs[`step${this.current+1}`]
      if (step && !step.validate()) {
        return false;
      }
      //验证通过,进入下一步
      switch (this.current) {
        case 0:
          this.current++
          this.cancelText = '上一步'
          break
        case 1:
        case 2:
        case 3:
          this.current++
          this.okText = '下一步'
          break
        case 4:
          this.current++
          this.okText = '确定'
          break
        case 5:
          //确定保存
          this.handleOk()
      }
    },
    prev(e) {
      /*右上角关闭操作直接关闭*/
      if (!e.target.innerText) {
        this.handleCancel()
        return
      }
      switch (this.current) {
        case 0:
          this.handleCancel()
          break
        case 1:
          this.current--
          this.cancelText = '关闭'
          break
        case 2:
        case 3:
        case 4:
        case 5:
          this.current--
          this.okText = '下一步'
          break
      }
    },

  }

}
</script>

<style scoped>
/deep/ .ant-tabs-bar {
  display: none;
}

.footer-btn {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  /*background: #fff;*/
  border-radius: 0 0 4px 4px;
  z-index: 9;
  background: #F8F8F8;
}

/deep/.ant-drawer-header {
  background: #F8F8F8;
}


</style>
